import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Particle from "../Particle";
import nuroFitLogo from "../../Assets/nurofit-logo.png";

function NuroFit() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Container
      fluid
      className="about-section"
      style={{
        background: "linear-gradient(180deg, #121212 0%, #1a1a1a 100%)",
      }}
    >
      <Particle />
      <Container>
        {/* Hero Section */}
        <Row
          className="align-items-center mb-5"
          style={{ padding: "60px 10px 20px" }}
        >
          <Col lg={6} className="text-center text-lg-start mb-4 mb-lg-0">
            <h1
              style={{
                fontSize: "3.8em",
                fontWeight: "700",
                background: "linear-gradient(90deg, #805AD5 0%, #D53F8C 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              NuroFit
            </h1>
            <h2
              style={{
                fontSize: "1.8em",
                color: "#e0e0e0",
                marginBottom: "25px",
              }}
            >
              Your Personal AI Fitness Coach
            </h2>
            <p
              style={{
                fontSize: "1.2em",
                lineHeight: "1.7",
                color: "#b0b0b0",
                maxWidth: "540px",
                margin: "0 auto 30px auto",
              }}
            >
              Transform your fitness journey with personalized workouts,
              nutrition tracking, and analytics powered by artificial
              intelligence.
            </p>
            <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start">
              <Button
                variant="primary"
                href="https://apps.apple.com/us/app/nurofit/id6744124558"
                target="_blank"
                style={{
                  background:
                    "linear-gradient(90deg, #805AD5 0%, #D53F8C 100%)",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "30px",
                  fontSize: "1.1em",
                  marginRight: "15px",
                  marginBottom: "15px",
                  boxShadow: "0 4px 20px rgba(128, 90, 213, 0.3)",
                }}
              >
                Download on App Store
              </Button>
              
              <Button
                variant="outline-light"
                href="https://play.google.com/store/apps/details?id=com.nurofit.core"
                target="_blank"
                style={{
                  borderColor: "#805AD5",
                  padding: "10px 25px",
                  borderRadius: "30px",
                  fontSize: "1.1em",
                  marginBottom: "15px",
                  boxShadow: "0 4px 20px rgba(128, 90, 213, 0.15)",
                }}
              >
                Get on Google Play
              </Button>
            </div>
          </Col>
          <Col lg={6} className="text-center">
            <div
              style={{
                background: "rgba(255, 255, 255, 0.05)",
                borderRadius: "20px",
                padding: "40px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              }}
            >
              <img
                src={nuroFitLogo}
                alt="NuroFit App"
                className="img-fluid"
                style={{
                  maxHeight: "300px",
                  filter: "drop-shadow(0 10px 20px rgba(128, 90, 213, 0.4))",
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Features Section */}
        <Row className="justify-content-center mt-5 mb-5">
          <Col lg={12} className="text-center mb-5">
            <h2
              style={{
                fontSize: "2.5em",
                fontWeight: "600",
                color: "#e0e0e0",
                marginBottom: "50px",
              }}
            >
              Intelligent Features
            </h2>
          </Col>

          {[
            {
              title: "Smart Workout Plans",
              description:
                "Personalized routines that adapt based on your performance, goals, and available equipment.",
              icon: "🏋️‍♂️",
            },
            {
              title: "Nutrition Intelligence",
              description:
                "Scan barcodes, track macros, and receive personalized meal recommendations based on your goals.",
              icon: "🥗",
            },
            {
              title: "Progress Analytics",
              description:
                "Visualize your journey with detailed charts and insights to keep you motivated and informed.",
              icon: "📊",
            },
            {
              title: "Health Integration",
              description:
                "Seamlessly connects with Apple Health and Google Fit to provide a comprehensive fitness overview.",
              icon: "❤️",
            },
            {
              title: "Exercise Library",
              description:
                "Access to hundreds of exercise demonstrations with proper form guidance and variations.",
              icon: "📚",
            },
            {
              title: "Social Community",
              description:
                "Connect with friends, share achievements, and participate in challenges for added motivation.",
              icon: "👥",
            },
          ].map((feature, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card
                style={{
                  background: "rgba(255, 255, 255, 0.03)",
                  border: "1px solid rgba(255, 255, 255, 0.05)",
                  borderRadius: "15px",
                  padding: "10px",
                  height: "100%",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                  overflow: "hidden",
                }}
                className="hover-card"
              >
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div
                    style={{
                      fontSize: "2.5em",
                      marginBottom: "15px",
                      color: "#9F7AEA", // Changed from gradient to solid color for better visibility
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      background: "rgba(159, 122, 234, 0.15)", // Light purple background
                      boxShadow: "0 4px 12px rgba(159, 122, 234, 0.2)",
                    }}
                  >
                    {feature.icon}
                  </div>
                  <Card.Title
                    style={{
                      fontSize: "1.4em",
                      color: "#e0e0e0",
                      marginBottom: "15px",
                    }}
                  >
                    {feature.title}
                  </Card.Title>
                  <Card.Text style={{ color: "#b0b0b0", fontSize: "1rem" }}>
                    {feature.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Technology Section */}
        <Row
          className="justify-content-center mt-5 mb-5"
          style={{
            background: "rgba(255, 255, 255, 0.02)",
            borderRadius: "20px",
            padding: "50px 30px",
            margin: "20px 0 50px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Col md={10} lg={8} className="text-center">
            <h2
              style={{
                fontSize: "2.2em",
                color: "#e0e0e0",
                marginBottom: "20px",
              }}
            >
              Built with Modern Technology
            </h2>
            <p
              style={{
                color: "#b0b0b0",
                fontSize: "1.1em",
                lineHeight: "1.7",
                marginBottom: "40px",
              }}
            >
              NuroFit leverages cutting-edge technologies to deliver a seamless
              and powerful fitness experience.
            </p>

            <div className="d-flex flex-wrap justify-content-center">
              {["Flutter", "Supabase", "Stripe", "REST API"].map(
                (tech) => (
                  <div
                    key={tech}
                    style={{
                      background: "rgba(128, 90, 213, 0.1)",
                      borderRadius: "30px",
                      padding: "10px 20px",
                      margin: "5px",
                      color: "#e0e0e0",
                      border: "1px solid rgba(128, 90, 213, 0.3)",
                    }}
                  >
                    {tech}
                  </div>
                )
              )}
            </div>
          </Col>
        </Row>

        {/* Legal Links Section - UPDATED with z-index and better highlighting */}
        <Row className="mt-5">
          <Col className="text-center mb-5">
            <div
              style={{
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                paddingTop: "30px",
                marginTop: "30px",
                position: "relative", // Added position relative
                zIndex: 10, // Added z-index to lift above other elements
              }}
            >
              <Button
                variant="link"
                onClick={() => navigate("/nurofit/privacypolicy")} // Simplified navigation
                style={{
                  color: "#b0b0b0",
                  textDecoration: "underline", // Added underline to make it look more like a link
                  margin: "0 15px",
                  transition: "all 0.3s",
                  padding: "15px 20px", // Increased padding for bigger click area
                  background: "rgba(128, 90, 213, 0.05)", // Subtle background
                  border: "1px solid rgba(128, 90, 213, 0.1)", // Subtle border
                  borderRadius: "8px", // Rounded corners
                  position: "relative", // Added position
                  zIndex: 20, // Higher z-index
                  cursor: "pointer", // Explicit pointer cursor
                }}
                className="legal-link"
              >
                Privacy Policy
              </Button>
              <Button
                variant="link"
                onClick={() => navigate("/nurofit/terms")} // Simplified navigation
                style={{
                  color: "#b0b0b0",
                  textDecoration: "underline", // Added underline to make it look more like a link
                  margin: "0 15px",
                  transition: "all 0.3s",
                  padding: "15px 20px", // Increased padding for bigger click area
                  background: "rgba(128, 90, 213, 0.05)", // Subtle background
                  border: "1px solid rgba(128, 90, 213, 0.1)", // Subtle border
                  borderRadius: "8px", // Rounded corners
                  position: "relative", // Added position
                  zIndex: 20, // Higher z-index
                  cursor: "pointer", // Explicit pointer cursor
                }}
                className="legal-link"
              >
                Terms & Conditions
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Add custom CSS */}
      <style>{`
        .hover-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(128, 90, 213, 0.3) !important;
        }

        .legal-link:hover {
          color: #805ad5 !important;
        }

        @media (max-width: 768px) {
          .hover-card {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </Container>
  );
}

export default NuroFit;
